exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "button.square[data-v-2eec76d4]{padding:.75rem 0;cursor:pointer}.di-divider-create[data-v-2eec76d4]:before,.di-divider-move[data-v-2eec76d4]:before,.di-job[data-v-2eec76d4]:before{font-size:2rem;border:2px solid #c2c2c2;padding:10px}input[type=number][data-v-2eec76d4]{border:2px solid #c2c2c2;padding:3px 10px;width:-webkit-fill-available}.left-panel[data-v-2eec76d4]{border:2px solid #ebebeb;padding:20px;background-color:#eee}label[data-v-2eec76d4]{display:inline-block;margin-bottom:0;font-size:11px}.active span[data-v-2eec76d4]:before{border:2px solid #10a5e5}.col-3[data-v-2eec76d4]{max-width:20%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2eec76d4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/mepsaws/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/dialogs/modalDivider.vue
// module id = 1535
// module chunks = 179